<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model
      ref="form"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="公司名称"
        prop="companyName"
      >
        <a-input
          v-model="form.companyName"
          placeholder="请输入公司名称"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="公司地址"
        prop="companyAddress"
      >
        <a-input
          v-model="form.companyAddress"
          placeholder="请输入公司地址"
          :maxLength="50"
        />
      </a-form-model-item>

      <a-form-model-item
        label="联系人"
        prop="nickName"
      >
        <a-input
          v-model="form.nickName"
          placeholder="请输入联系人"
          :maxLength="20"
        />
      </a-form-model-item>
      <a-form-model-item
        label="电话"
        prop="phoneNumber"
      >
        <a-input
          v-model="form.phoneNumber"
          placeholder="请输入电话"
          :maxLength="11"
          oninput="value=value.replace(/[^\d]/g,'')"
        />
      </a-form-model-item>
      <a-form-model-item
        label="头像"
        prop="nickname"
      >
        <div
          class="ant-upload-preview"
          @click="$refs.upImg.edit(form.avatar)"
        >
          <div
            class="mask"
            :style="form.avatar ? 'opacity: 0' : 'opacity: 1'"
          >
            <a-icon type="plus" />
          </div>
          <img
            :src="$url + form.avatar"
            v-if="form.avatar"
            style="width: 100px;height: 100px"
          />
        </div>
      </a-form-model-item>
      <a-form-model-item
        label="系统登录名"
        prop="userName"
      >
        <a-input
          v-model="form.userName"
          placeholder="请输入系统登录名"
          :maxLength="30"
        />
      </a-form-model-item>
      <a-form-model-item
        label="系统登录密码"
        prop="password"
        v-if='formType == 1'
      >
        <a-input
          v-model="form.password"
          placeholder="请输入系统登录密码"
          :maxLength="12"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button
            type="primary"
            :loading="submitLoading"
            @click="submitForm"
          >
            保存
          </a-button>
          <a-button
            type="dashed"
            @click="cancel"
          >
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <up-img-modal
      ref="upImg"
      :width="200"
      :height="200"
      @ok="setImg"
    />
  </a-drawer>
</template>

<script>
import { getUser, addUser, updateUser } from '@/api/system/user'
import upImgModal from '@/components/upImgModal'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false
    }
  },
  components: {
    upImgModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        userType: '04',
        id: null,
        userName: null,
        phoneNumber: null,
        password: null,
        nickName: null,
        status: 1,
        createTime: null,
        companyName: null,
        avatar: null,
        companyAddress: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        companyName: [
          { required: true, message: '公司名称不能为空', trigger: 'blur' }
        ],
        nickName: [
          { required: true, message: '联系人不能为空', trigger: 'blur' }
        ],
        phoneNumber: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请正确填写手机号',
            trigger: 'blur'
          }
        ],
        userName: [
          { required: true, message: '系统登录名不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '系统登录密码不能为空', trigger: 'change' },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{}|;:,.?~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{}|;:,.?~]{8,20}$/,
            message: '密码为（字母+数字+特殊符号）长度 8~20 位',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    setImg (url) {
      console.log(url, '大大大大大====')
      this.form.avatar = url
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        userType: '04',
        id: null,
        userName: null,
        phoneNumber: null,
        password: null,
        nickName: null,
        status: 1,
        companyName: null,
        avatar: null,
        companyAddress: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getUser(id).then(response => {
        this.form = response.data.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateUser(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addUser(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less">
.ant-upload-preview {
  position: relative;
  width: 100px;
  height: 100px;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border: 1px solid rgba(0, 0, 0, 0.2);
  }

  .mask {
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    overflow: hidden;
    object-fit: contain;
  }
}
</style>
